module.exports = __webpack_public_path__ + "static/media/add-friends-placeholder.8fbb99bc.svg";